import { POINTS_V82_LIVE, purchasePoints, REVIEW_POINTS as REVIEW_POINTS_V4 } from "./pointsRules";
import {
    DIET_CONSULTATION_AMOUNT,
    ZOG_CONSULTATION_AMOUNT,
} from "./stripe";

/**
 * Предложения вокруг диагностик из нового вида «Диета и диагностика»
 * (пока его видят только администраторы). Всё, что меняет деньги, выключено
 * до согласования с владельцем: экран это показывает, но ничего не списывает.
 * Баллы таблицы v8.2 для администраторов уже настоящие (POINTS_V82_LIVE).
 */

/*
 * ГДЕ СЕЙЧАС ЗАКАЗЫВАЮТ ДИАГНОСТИКУ. Владелец, 28.09.2026: «заказ
 * диагностики ЗОЖ пока должен быть по ссылке ogtorsunov.ru, а заказ диет
 * должен быть скоро в продаже». Всё про это — здесь, в одном месте:
 * вернуть заказ на сайт — перевернуть переключатель.
 *
 * С 09.10.2026 — у всех, не только у администраторов. Владелец: «не надо
 * пока открывать возможность заказывать диагностику диет, а для диагностики
 * ЗОЖ поставь ссылку на сайт ogtorsunov.ru как сейчас админы это видят
 * сделай это для всех». Переключатели слушают: новые экраны администраторов
 * (DietHubV5, «Все продукты», новые карточки «Мои консультации»), прежние
 * карточки «Мои консультации» у всех остальных и сама анкета новой
 * диагностики (DiagnosticQuestionnairePage: без ?edit= и не «site» — вместо
 * формы NewOrderClosed). Уже начатая или пройденная диагностика видна как
 * раньше (правка анкеты, данные о здоровье, оплата одобренной, результаты):
 * переключатели меняют только то, как заказать НОВУЮ.
 */

/** Куда вести заказ диагностики ЗОЖ, пока её заказывают не у нас (корень сайта: какую страницу там открыть — не решено). */
export const ZOG_ORDER_URL = "https://ogtorsunov.ru";

/**
 * true — ЗОЖ заказывают на ZOG_ORDER_URL (в новой вкладке, с пометкой «↗»):
 * ни анкеты у нас, ни цены, ни баллов — покупка там до наших баллов не доходит.
 * false — как раньше: анкета у нас, оплата после одобрения.
 */
export const ZOG_ORDER_EXTERNAL = true;

/**
 * false — диагностика диеты «скоро в продаже»: ни цены, ни кнопки, ни оплаты.
 * true — как раньше: анкета у нас, оплата после одобрения.
 */
export const DIET_ON_SALE = false;

/**
 * КОМУ ДИЕТУ ЗАКАЗЫВАЮТ У НАС УЖЕ СЕЙЧАС. Владелец, 09.10.2026: «сделай чтобы
 * elnurkulmuhanov@gmail.com мог создать заявку на диагностику диеты на
 * торсунов.ком». Для этих адресов — как при DIET_ON_SALE = true: $300,
 * «Начать», анкета ?type=diet, оплата после одобрения. У всех остальных —
 * по DIET_ON_SALE (сейчас «скоро в продаже»). Адрес — тот, с которым человек
 * вошёл на сайт (useDiagnosticSale); сравнение без регистра и пробелов по краям.
 * ЗОЖ, «Обе сразу» и оплату список не меняет.
 *
 * Владелец, 22.10.2026: «открой для всех юзеров из этого списка … возможность
 * заполнить анкету на диагностику диет на торсунов.ком» — 11 адресов группы
 * «тестирование диет» (Google-таблица 1rMERy9WpCeKsPZprXiqodljDUumxYC7cdhJbgKBCPwQ,
 * колонка «мейл»). Только .com: копию в ru_version (торсунов.лайф) не трогали.
 * Владелец, 26.10.2026: «там добавились еще люди, открой им доступ» — новый адрес
 * той же таблицы; затем «проверь еще какие мейлы новые» — ещё два адреса оттуда.
 */
export const DIET_ORDER_EMAILS: readonly string[] = [
    "elnurkulmuhanov@gmail.com",
    // «тестирование диет», 22.10.2026:
    "daoberik@gmail.com",
    "dgdbvgm@gmail.com",
    "dmitriyt21@gmail.com",
    "lexxbla@gmail.com",
    "mskojaktm@gmail.com",
    "revival600@gmail.com",
    "sibikovskaya@gmail.com",
    "snegovik0610@gmail.com",
    "xenona17@gmail.com",
    // «тестирование диет», добавлен в таблицу позже, 26.10.2026:
    "artur.chirkov.ed@gmail.com",
    // та же таблица, 26.10.2026 позже: новый адрес и исправленный адрес (был @mail.ru);
    // 29.10.2026 прежние aya.lina@mail.ru и gedzanna@mail.ru убраны — в таблице их больше нет:
    "aigerim.butabaeva@gmail.com",
    "gedzanna@gmail.com",
    // та же таблица, 27.10.2026: ещё один адрес
    "chirkov.artur.ed@gmail.com",
];

const normEmail = (email: string | null | undefined) => (email || "").trim().toLowerCase();

/** Этому человеку диету уже сейчас заказывают у нас (DIET_ORDER_EMAILS). */
export const dietOrderAllowed = (email: string | null | undefined): boolean => {
    const e = normEmail(email);
    return !!e && DIET_ORDER_EMAILS.some((x) => normEmail(x) === e);
};

export type DiagnosticKind = "diet" | "zog";

/** Как сейчас заказать новую диагностику: у нас («site»), на другом сайте («external») или никак («soon»). */
export type DiagnosticSale = "site" | "external" | "soon";

/**
 * Как заказать новую диагностику человеку с этим адресом (адреса нет — как всем).
 * В экранах — через useDiagnosticSale(): он подставляет адрес вошедшего.
 */
export const diagnosticSale = (type: DiagnosticKind, email?: string | null): DiagnosticSale =>
    type === "zog"
        ? ZOG_ORDER_EXTERNAL
            ? "external"
            : "site"
        : DIET_ON_SALE || dietOrderAllowed(email)
          ? "site"
          : "soon";

/** diagnosticSale для одного человека (его вернёт useDiagnosticSale). */
export type DiagnosticSaleOf = (type: DiagnosticKind) => DiagnosticSale;

/**
 * Какой переключатель решает за анкету вида `type` (?type= в адресе анкеты).
 * Анкета без вида («general») оплачивается как ЗОЖ (createConsultationCheckout:
 * всё, что не диета, — по цене и под названием ЗОЖ) — значит, и заказывается как ЗОЖ.
 */
export const diagnosticKindOf = (type: string | null | undefined): DiagnosticKind =>
    type === "diet" ? "diet" : "zog";

/**
 * «Обе сразу» можно хотя бы показать, только когда обе диагностики
 * заказывают у нас. Сейчас (диета — скоро, ЗОЖ — на ogtorsunov.ru) комплект
 * не предлагается нигде; купить его по-прежнему нельзя, пока выключен
 * DIAGNOSTICS_BUNDLE_ENABLED. Считается для всех, без DIET_ORDER_EMAILS.
 */
export const DIAGNOSTICS_BUNDLE_SHOWN =
    diagnosticSale("diet") === "site" && diagnosticSale("zog") === "site";

/*
 * ВНИМАНИЕ: три флага ниже меняют ТОЛЬКО то, что написано на экране.
 * Ни оплата, ни начисление баллов за ними не подключены. Не включать,
 * пока сервер этого не умеет — иначе экран пообещает то, чего не будет.
 * Тест diagnosticsOffer.test.ts держит их в нужном положении: включая флаг,
 * сначала подключите сервер, потом поменяйте тест.
 *
 * Баллы (DIAGNOSTICS_POINTS_ENABLED, REVIEW_POINTS_ENABLED) сервер с 29.09
 * начисляет по таблице v8.2 и показывает администраторам (а этот вид видят
 * только они), поэтому они идут за общим переключателем POINTS_V82_LIVE.
 * Деньги («Обе сразу», DIAGNOSTICS_BUNDLE_ENABLED) — по-прежнему выключены.
 */

/**
 * «Обе сразу — скидка 20 %» ($480 вместо $600). Выключено: оплату по
 * сниженной цене сервер не умеет и не согласована. Пока false, выбор
 * «Обе сразу» виден администратору с пометкой «включится после
 * согласования», а «Начать» для него не работает — платить можно только
 * за каждую диагностику по обычной цене, как сейчас.
 *
 * НЕ ВКЛЮЧАТЬ, пока оплата не умеет комплект: сейчас «Обе сразу»
 * (DietHubV5 → onStart("both")) открыло бы только анкету диеты, а
 * оплата по одобрении списала бы $300 + $300, хотя экран обещает $480.
 */
export const DIAGNOSTICS_BUNDLE_ENABLED = false;

/**
 * Баллы вклада за покупку диагностики — по таблице баллов v8.2 (pointsRules.purchasePoints,
 * вид «diagnostic»: 10 за $1 цены без скидки, вне годового порога). ВКЛ вместе с
 * POINTS_V82_LIVE: сервер начисляет их (администраторы видят) — чип сплошной, без
 * «предложение». Выключат — пунктирное «предложение» и пометка «сегодня баллов не даёт».
 * Флаг меняет только надпись, сам ничего не начисляет.
 */
export const DIAGNOSTICS_POINTS_ENABLED: boolean = POINTS_V82_LIVE;

/**
 * «+500 вклад» за любой отзыв (таблица баллов v8.2; на доске V4_F4 — рядом с
 * «Оставить отзыв»). ВКЛ вместе с POINTS_V82_LIVE: сервер начисляет, чип
 * сплошной. Выключат — пунктирное «предложение» с пометкой «включится после
 * согласования». Флаг меняет только надпись.
 */
export const REVIEW_POINTS_ENABLED: boolean = POINTS_V82_LIVE;
export const REVIEW_POINTS = REVIEW_POINTS_V4;

/** Скидка за обе диагностики сразу (доля). */
export const DIAGNOSTICS_BUNDLE_DISCOUNT = 0.2;

/**
 * Предлагаемые баллы вклада за одну диагностику и за обе (таблица v8.2): 10 за $1, вне годового
 * порога — поэтому в любой момент года одинаково: $300 → 3 000. Обе сразу считаются по цене без
 * скидки: $300 + $300 → 6 000.
 */
export const DIAGNOSTICS_POINTS_SINGLE = purchasePoints(ZOG_CONSULTATION_AMOUNT, 0, "diagnostic");
export const DIAGNOSTICS_POINTS_BOTH = purchasePoints(DIET_CONSULTATION_AMOUNT + ZOG_CONSULTATION_AMOUNT, 0, "diagnostic");

/** Цены в долларах (суммы Stripe — в центах). */
export const DIET_PRICE_USD = DIET_CONSULTATION_AMOUNT / 100;
export const ZOG_PRICE_USD = ZOG_CONSULTATION_AMOUNT / 100;
export const BOTH_FULL_PRICE_USD = DIET_PRICE_USD + ZOG_PRICE_USD;
export const BOTH_PRICE_USD = Math.round(
    BOTH_FULL_PRICE_USD * (1 - DIAGNOSTICS_BUNDLE_DISCOUNT),
);
export const BUNDLE_DISCOUNT_PERCENT = Math.round(
    DIAGNOSTICS_BUNDLE_DISCOUNT * 100,
);
